<template>
  <div class="indicator"
    v-bind:class="{
      selected: val,
    }"
    v-bind:style="{
      width: `${size}px`,
      minWidth: `${size} px`,
      height: `${size}px`,
      borderWidth: `${size / 8}px`,
    }">
    <div class="ind"
      v-bind:style="{
        width: `${size / 2.5}px`,
        height: `${size / 2.5}px`,
      }"></div>
  </div>
</template>

<script>
export default {
  props: ['size', 'mode', 'val'],
  data() {
    return {
    };
  },
  watch: {
    val() {
      console.warn('val changed: ', this.val);
    },
  },
};
</script>

<style lang="scss" scoped>
.indicator {
  border-radius: 50%;
  position: relative;
  border-style: solid;
  transition: all ease-in-out 0.2s;
  margin-left: 8px;
  border-color: var(--normalText3);
  .ind {
    position: absolute;
    transition: all ease-in-out 0.2s;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    border-radius: 50%;
    background-color: var(--normalText5);
  }
}
.indicator.selected {
  border-color: var(--normalText8) !important;
  .ind {
    transform: translate(-50%, -50%) scale(1);
    background-color: var(--themeGreen7) !important;
  }
}
</style>
